import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#396a28";
function ELLA({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillRule="evenodd" d="M13.555 9.909L12 8.355l-1.565 1.564-1.623-1.623L12 3.75l3.21 4.504zm-3.662.553L8.355 12l1.554 1.555-1.617 1.617L3.75 12l4.493-3.187zm4.188 3.103L15.645 12l-1.548-1.548 1.67-1.67L20.25 12l-4.533 3.202zm-3.629.533L12 15.645l1.537-1.537 1.637 1.637L12 20.25l-3.153-4.548zM12 9.395L14.604 12 12 14.604 9.396 12z" clipRule="evenodd" /></Svg>;
}
ELLA.DefaultColor = DefaultColor;
export default ELLA;